module.exports = __webpack_public_path__ + "static/media/1-8.ce287d12.mp3";